module.exports = __webpack_public_path__ + "static/media/SWE.b4b1324d.svg";